document.addEventListener("DOMContentLoaded", function () {
  var tooltipSpan = document.getElementById("selected-swatch-tooltip");
  var radios = document.querySelectorAll(".ColorSwatch__Radio");
  var labels = document.querySelectorAll(".ColorSwatch[data-tooltip]");
  function setTooltip(value) {
    if (tooltipSpan) {
      tooltipSpan.textContent = value;
    }
  }
  // Inicial: valor seleccionado
  var checkedRadio = Array.from(radios).find(function (radio) {
    return radio.checked;
  });
  if (checkedRadio) {
    var label = checkedRadio.nextElementSibling;
    if (label && label.dataset.tooltip) {
      setTooltip(label.dataset.tooltip);
    }
  }
  // Hover: cambia el tooltip
  labels.forEach(function (label) {
    label.addEventListener("mouseenter", function () {
      setTooltip(label.dataset.tooltip);
    });
    label.addEventListener("mouseleave", function () {
      // Vuelve al seleccionado
      var checkedRadio = Array.from(radios).find(function (radio) {
        return radio.checked;
      });
      if (checkedRadio) {
        var selectedLabel = checkedRadio.nextElementSibling;
        if (selectedLabel && selectedLabel.dataset.tooltip) {
          setTooltip(selectedLabel.dataset.tooltip);
        }
      }
    });
  });
  // Cambio de selección
  radios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      var label = radio.nextElementSibling;
      if (label && label.dataset.tooltip) {
        setTooltip(label.dataset.tooltip);
      }
    });
  });
});
